import { useQuery } from '@pinia/colada';
import { computed } from 'vue';

import { PropertyStatus } from '@tallo/property';

import propertyService from '../services/property.service';

export const portfolioQueryKey = 'portfolio';

/** A building's units fit on one page of the list its page shows */
const unitsPageSize = 500;

export function getBuildingUnitsQueryKey(buildingId: string) {
  return [portfolioQueryKey, 'building', buildingId];
}

/** The building's units, as the properties page lists them: the same cards and rows */
export function useBuildingUnitsQuery(buildingId: () => string) {
  const { data, ...rest } = useQuery({
    key: () => getBuildingUnitsQueryKey(buildingId()),
    enabled: () => Boolean(buildingId()),
    query: () => propertyService.getPortfolio(1, unitsPageSize, buildingId()),
  });

  const units = computed(() => data.value?.properties ?? []);

  return { ...rest, data, units };
}

export function usePortfolioQuery() {
  const { state, data, ...rest } = useQuery({
    key: () => [portfolioQueryKey],
    query: () => propertyService.getPortfolio(1, 300),
  });

  const properties = computed(() => data.value?.properties || []);
  const hasActiveProperties = computed(() => {
    const activeProperties = properties.value.filter((property) => property.status !== PropertyStatus.DRAFT);

    return activeProperties.length > 0;
  });

  return {
    ...rest,
    state,
    data,
    properties,
    hasActiveProperties,
  };
}
